export default __webpack_public_path__ + "static/media/bg-6.1cb81a34.jpg";